jQuery(document).ready(function($){
  var current_url = window.location.href;
  $('li.tag-price').click(function () {
    $('li.tag-price').each((i,el)=>{
         $(el).removeClass("active");
    })
    $(this).addClass("active");
 });  
 
  $('label img').click(function () {
       $('label img').each((i,el)=>{
            $(el).removeClass("border-black");
       })
       $(this).addClass("border-black");
    });
    if (current_url.includes("products")) {
      var related_product_wait = setInterval(() => {
        console.log($('.recommendate_slider').length);
         if($('.recommendate_slider').length>0){
          $('.recommendate_slider').slick({
            infinite: true,
            slidesToShow: 3, // Shows a three slides at a time
            slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
            arrows: true, // Adds arrows to sides of slider
          });
          clearInterval(related_product_wait);
         }
       }, 10);
    }
    if (current_url.includes("collections")) {
        $('.size_variants .size_v').click(function () {
            $('.size_variants .size_v').each((i,el)=>{
              $(el).removeClass("active");
            })
            $(this).addClass("active");
        })
    }
    
    var sizeChart = setInterval(() => {
      if ($(".best-fit-size-chart").length > 0) {
        $('select.single-option-selector').after($(".best-fit-size-chart"));
        clearInterval(sizeChart)    
      }
    }, 10);

    $('.plus_quantity').click(function () {
      var str = $("#Quantity-product-template").val();
      var value = parseInt(str);
      value = value + 1;
      $("#Quantity-product-template").val(value);
    });

    $('.minus_quantity').click(function () {
      var str = $("#Quantity-product-template").val();
      var value = parseInt(str);
      value = value - 1;
      if(value < 1){
        value = 1;
      }
      $("#Quantity-product-template").val(value);
    });
});
